import React, { forwardRef } from 'react'

import { mergeRefs } from 'utils/ref_utils'

import { useHeadlessListboxContext } from './context'

interface HeadlessListboxListProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const HeadlessListboxList = forwardRef<
  HTMLDivElement,
  HeadlessListboxListProps
>(({ children, ...props }, forwardedRef) => {
  const { listRef } = useHeadlessListboxContext()

  return (
    <div {...props} ref={mergeRefs(listRef, forwardedRef)} role='listbox'>
      {children}
    </div>
  )
})

HeadlessListboxList.displayName = 'HeadlessListbox.List'
